function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#A5A7AA;}\n\t.st1{fill:#565759;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#F15F69;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M431.7,148.7V91.3c0-11.4-8.5-20.6-19.1-20.6H30.5C20,70.6,11.4,79.9,11.4,91.3v57.4H431.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M437.2,154.2H5.9V91.3c0-14.4,11-26.1,24.6-26.1h382.1c13.6,0,24.6,11.7,24.6,26.1V154.2z M16.9,143.2h409.3 V91.3c0-8.3-6.1-15.1-13.6-15.1H30.5c-7.5,0-13.6,6.8-13.6,15.1V143.2z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M11.4,195.9v104.7c0,11.4,8.5,20.6,19.1,20.6h382.1c10.5,0,19.1-9.2,19.1-20.6V195.9H11.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M412.6,326.8H30.5c-13.6,0-24.6-11.7-24.6-26.1V190.4h431.3v110.2C437.2,315,426.2,326.8,412.6,326.8z  M16.9,201.4v99.2c0,8.3,6.1,15.1,13.6,15.1h382.1c7.5,0,13.6-6.8,13.6-15.1v-99.2H16.9z"
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 129.5,
  className: "st1",
  width: 10.9,
  height: 81.1
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 426.2,
  y: 137.6,
  className: "st1",
  width: 10.9,
  height: 81.1
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 431.7,
  cy: 65.2,
  r: 58.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M431.7,129.3c-35.3,0-64.1-28.8-64.1-64.1s28.8-64.1,64.1-64.1c35.3,0,64.1,28.8,64.1,64.1 S467,129.3,431.7,129.3z M431.7,12.1c-29.3,0-53.1,23.8-53.1,53.1s23.8,53.1,53.1,53.1c29.3,0,53.1-23.8,53.1-53.1 S461,12.1,431.7,12.1z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M439.7,82.9L432,71.7l-7.8,11.2c-1.1,1.6-2.1,2.7-2.9,3.4c-0.8,0.7-1.8,1-3,1c-1.3,0-2.5-0.4-3.4-1.3 c-0.9-0.8-1.4-1.8-1.4-2.9s0.7-2.7,2.2-4.7l9.5-13.7l-8.4-11.4c-1.5-1.9-2.2-3.5-2.2-4.9c0-1.1,0.4-2,1.3-2.8 c0.9-0.8,2-1.2,3.4-1.2c1.2,0,2.3,0.3,3.1,1s1.8,1.8,2.8,3.3L432,58l6.6-9.3c1.1-1.5,2.1-2.6,2.9-3.3s1.8-1,3-1 c1.4,0,2.5,0.4,3.5,1.2c0.9,0.8,1.4,1.7,1.4,2.8c0,0.8-0.2,1.6-0.6,2.3c-0.4,0.7-0.9,1.6-1.7,2.6l-8.4,11.4l9.5,13.7 c1.5,2.1,2.2,3.7,2.2,4.8c0,1.1-0.5,2.1-1.4,2.9c-0.9,0.8-2.1,1.2-3.4,1.2c-1.2,0-2.2-0.3-3.1-1C441.7,85.6,440.7,84.4,439.7,82.9z "
}));

var SvgPaymentDeclined = function SvgPaymentDeclined(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 497.2 327.8",
    style: {
      enableBackground: "new 0 0 497.2 327.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaymentDeclined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment-declined.119d9717.svg";
export { ForwardRef as ReactComponent };